/*
 * The products a single order is created with, as the manual form holds them.
 *
 * Each entry is a product picked out of the seller's catalogue plus the typed
 * quantity (a string, as the field holds it). Only catalogue products: the
 * backend refuses a SKU it does not know, so that a typo cannot create one.
 */

/**
 * Something wrong with each quantity, by SKU. Empty when they can all go.
 *
 * @param {Array<{sku: string, quantity: string}>} products
 * @returns {Object<string, string>}
 */
export const validateOrderProducts = (products) => {
  const errors = {};
  (products || []).forEach((entry) => {
    const quantity = Number(entry.quantity);
    if (entry.quantity === '' || !Number.isInteger(quantity) || quantity <= 0) {
      errors[entry.sku] = 'Debe ser un entero mayor a cero';
    }
  });
  return errors;
};

/**
 * What the backend takes: `[{sku, quantity}]`, or `undefined` when nothing was
 * picked, so that the order is created exactly as it was before this existed.
 *
 * @param {Array<{sku: string, quantity: string}>} products
 * @returns {Array<{sku: string, quantity: number}>|undefined}
 */
export const buildProductsPayload = (products) => {
  if (!products || products.length === 0) return undefined;
  return products.map((entry) => ({ sku: entry.sku, quantity: Number(entry.quantity) }));
};

/**
 * Adds a catalogue product to the picked list, once: picking the same SKU
 * again leaves the list as it was.
 *
 * @param {Array<object>} products
 * @param {object} product - As `products/order_form_products/` serves it.
 * @returns {Array<object>}
 */
export const addOrderProduct = (products, product) => {
  if (products.some((entry) => entry.sku === product.sku)) return products;
  return [
    ...products,
    {
      id: product.id,
      sku: product.sku,
      name: product.name,
      weight: product.weight,
      dimensions: product.dimensions,
      quantity: '1',
    },
  ];
};
